<!-- 合作页面点击gotoCooperationDetail调转至该页面  合作细节页面 -->
<template>
  <div class="cooperationDetailDiv">
    <div class="cooperationDetail">
      <div class="card">
        <div class="tite">{{ this.detail.siName }}</div>
        <div class="company">需求企业：{{ this.detail.siCompanyName }}</div>
        <div class="name">需求联系人：{{ this.detail.siAlumniName }}</div>
        <div class="telDiv clearfix">
          <div class="tel">联系方式：{{ this.detail.siPhone }}</div>
          <div class="telIconDiv">
            <a :href="'tel' + ':' + this.detail.siPhone">
              <img
                src="../../assets/image/btn_dianhua_nor.png"
                alt="电话"
                class="telIcon"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="detail">
        <div class="title clearfix">
          <div class="icon"></div>
          <div class="titleName">需求详情</div>
        </div>
        <div class="description">{{ this.detail.siDescription }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: "",
    };
  },
  created() {
    this.getCooperationDetail();
  },
  methods: {
    async getCooperationDetail() {
      const result = await this.$http.get("/achievementTransform/getNeedByName", {
        params: { id: this.$route.query.sId },
      });
      this.detail = result.data.AchievementByName;
    },
  },
};
</script>
<style lang="less" scoped>
.cooperationDetailDiv {
  position: relative;
  .cooperationDetail {
    position: relative;
    left: 5%;
    width: 90%;
    .card {
      margin-top: 10px;
      background: #ffffff;
      border: 1px solid #e1e1e1;
      border-radius: 15px;
      .tite {
        margin: 10px 0 10px 10px;
        font-size: 1.1rem;
        font-weight: bold;
        color: #333333;
      }
      .company,
      .name {
        margin: 10px 0 10px 10px;
        font-weight: bold;
        color: #666666;
      }
      .telDiv {
        position: relative;
        left: 3%;
        margin: 10px 0;
        .tel {
          float: left;
          font-weight: bold;
          color: #666666;
        }
        .telIconDiv {
          float: left;
          width: 12px;
          margin-left: 5px;
          .telIcon {
            width: 100%;
          }
        }
      }
    }
    .detail {
      .description {
        margin-top: 10px;
        text-indent: 2em;
        font-weight: 400;
        color: #333333;
        line-height: 2rem;
        word-wrap: break-word;
        word-break: break-all;
      }
    }
  }
}
.title {
  position: relative;
  margin-top: 20px;
  .icon {
    float: left;
    height: 5vw;
    width: 3px;
    background: #00706E;
    border-radius: 3px;
  }
  .titleName {
    float: left;
    margin-left: 5px;
    font-size: 1.1rem;
    font-weight: bold;
    color: #333333;
  }
}
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/achievements/CooperationDetail.vue